/**
 * Matches legacy FutureOrderTimeCard: ASAP only when pickup is within the LD threshold.
 * @see workspaces/frontend/src/pages/cart/future-order-time-card/future-order-time-card.tsx
 */
export function shouldShowAsapPickupTime(
  pickupTime: Date,
  asapThresholdMinutes: number,
  earliestPickupTimeInSeconds = 0
): boolean {
  if (asapThresholdMinutes <= 0) {
    return false;
  }

  const thresholdMs = asapThresholdMinutes * 60 * 1000;
  const earliestMs = Number(earliestPickupTimeInSeconds) * 1000;

  // Order minimum lead time exceeds ASAP window — show a concrete time instead.
  if (earliestMs > thresholdMs) {
    return false;
  }

  return pickupTime.getTime() - Date.now() <= thresholdMs;
}

/**
 * Checkout summary only — ASAP on first load before the user has ever confirmed.
 * After confirm (or when the 5-minute filter advances the default), show the slot time.
 */
export function shouldShowAsapOnCheckoutSummary(
  pickupTime: Date,
  asapThresholdMinutes: number,
  earliestPickupTimeInSeconds: number,
  allowAsapLabel: boolean
): boolean {
  if (!allowAsapLabel) {
    return false;
  }

  return shouldShowAsapPickupTime(
    pickupTime,
    asapThresholdMinutes,
    earliestPickupTimeInSeconds
  );
}
